/**
 * Open quick view modal with pre-rendered Liquid content (no fetch).
 */
(function() {
  var modalContainer = null;
  var modalContent = null;

  function getModal() {
    if (modalContainer) return { container: modalContainer, content: modalContent };
    modalContainer = document.querySelector('[data-modal-container]');
    modalContent = modalContainer && modalContainer.querySelector('[data-modal-content]');
    return { container: modalContainer, content: modalContent };
  }

  function openQuickView(html) {
    var m = getModal();
    if (!m.content) return;
    m.content.innerHTML = html;
    m.container.classList.add('modal--quickshop-full');
    document.body.classList.add('modal-loaded', 'modal-visible');
    if (window.initShopifyProductReviews) window.initShopifyProductReviews();
    if (window.BV && typeof window.BV.ui === 'function') {
      var pid = m.content.querySelector('[data-bv-product-id]');
      if (pid) window.BV.ui('rr', 'show_reviews', { productId: pid.getAttribute('data-bv-product-id') });
    }
    bindClose();
  }

  function closeQuickView() {
    document.body.classList.remove('modal-visible');
    var c = document.querySelector('[data-modal-container].modal--quickshop-full');
    if (c) c.classList.remove('modal--quickshop-full');
  }

  function bindClose() {
    var closeBtn = document.querySelector('[data-modal-close]');
    var container = document.querySelector('[data-modal-container]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function onClose() {
        closeQuickView();
        closeBtn.removeEventListener('click', onClose);
      }, { once: true });
    }
    if (container) {
      container.addEventListener('click', function(e) {
        if (e.target === container) closeQuickView();
      }, { once: true });
    }
    document.addEventListener('keydown', function esc(e) {
      if (e.key === 'Escape') {
        closeQuickView();
        document.removeEventListener('keydown', esc);
      }
    }, { once: true });
  }

  function init() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest && e.target.closest('[data-quick-view-open]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var handle = btn.getAttribute('data-quick-view-handle');
      if (!handle) return;
      var card = btn.closest('.productgrid--item');
      if (!card) return;
      var contentEl = card.querySelector('[data-quick-view-content][data-quick-view-handle="' + handle + '"]');
      if (!contentEl) return;
      openQuickView(contentEl.innerHTML);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
